"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiKitFileDrop = void 0;
const react_1 = __importStar(require("react"));
const UiKitBase_1 = require("./UiKitBase");
const UiKitFileDrop = (props) => {
    const [dragActive, setDragActive] = (0, react_1.useState)(false);
    const [showErrorText, setShowErrorText] = (0, react_1.useState)('none');
    const onDrag = e => {
        e.preventDefault();
        if (e.type === 'dragenter' || e.type === 'dragover') {
            setDragActive(true);
        }
        else if (e.type === 'dragleave') {
            setDragActive(false);
        }
    };
    const allowedFileTypes = props.accept.map(acceptExtension => {
        const mappings = {
            '.pdf': 'application/pdf',
        };
        return mappings[acceptExtension];
    });
    const onDrop = e => {
        e.preventDefault();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            let validFiles = true;
            Array.from(e.dataTransfer.files).forEach((file) => {
                if (!allowedFileTypes.includes(file.type)) {
                    setShowErrorText('type');
                    validFiles = false;
                }
                else if (file.size > props.maxFileSizeBytes) {
                    setShowErrorText('size');
                    validFiles = false;
                }
            });
            if (validFiles) {
                setShowErrorText('none');
                props.onFiles(e.dataTransfer.files);
            }
        }
    };
    const onClick = (event) => {
        if (event.target.files && event.target.files[0]) {
            let validFiles = true;
            Array.from(event.target.files).forEach((file) => {
                if (file.size > props.maxFileSizeBytes) {
                    setShowErrorText('size');
                    validFiles = false;
                }
            });
            if (validFiles) {
                setShowErrorText('none');
                props.onFiles(event.target.files);
            }
        }
    };
    return (react_1.default.createElement("form", { onDragEnter: onDrag, style: {
            height: '16rem',
            width: '28rem',
        } },
        react_1.default.createElement("input", { type: "file", id: "input-file-upload", accept: props.accept.join(','), multiple: true, onChange: onClick, style: { display: 'none' } }),
        react_1.default.createElement("label", { htmlFor: "input-file-upload", style: {
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderWidth: '2px',
                borderRadius: UiKitBase_1.UiKitBase.consistency.borderRadius,
                borderStyle: 'dashed',
                borderColor: UiKitBase_1.UiKitBase.consistency.primaryBlue10,
                backgroundColor: dragActive ? UiKitBase_1.UiKitBase.consistency.pageBackground : UiKitBase_1.UiKitBase.consistency.gray03,
            } },
            react_1.default.createElement("div", null, showErrorText === 'size' ? (react_1.default.createElement(UiKitBase_1.UiKitBase.Text.BodyRegular, { color: UiKitBase_1.UiKitBase.consistency.error70 },
                "All files must be under ",
                props.maxFileSizeBytes / (1024 * 1024),
                "MB in size.")) : showErrorText === 'type' ? (react_1.default.createElement(UiKitBase_1.UiKitBase.Text.BodyRegular, { color: UiKitBase_1.UiKitBase.consistency.error70 }, "Incorrect file type. Please try again.")) : (react_1.default.createElement(UiKitBase_1.UiKitBase.Text.BodyRegular, null, "Drag file here or click to select file")))),
        dragActive && (react_1.default.createElement("div", { onDragEnter: onDrag, onDragLeave: onDrag, onDragOver: onDrag, onDrop: onDrop, style: {
                height: '100%',
                width: '100%',
                position: 'absolute',
                borderRadius: '1rem',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            } }))));
};
exports.UiKitFileDrop = UiKitFileDrop;
